<div class="font-selector">
    <label for="font-size">Font Size:&nbsp;</label>
    <select id="font-size" (change)="onFontSizeChange($event)" aria-label="Select Font Size">
        <option *ngFor="let size of fontSizes" [value]="size.value" [selected]="size.value === selectedFontSize">
            {{ size.label }}
        </option>
    </select>
</div>